/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useNavigate } from "react-router-dom";
import { translate } from "../../../../../../common/providers";
import styles from "./OpenCommitmentsPanel.module.css";

export default function OpenCommitmentsPanel() {
	const navigate = useNavigate();

	const handleNavigateToFeatures = () => {
		navigate("/dsi/agent/agent-feature");
	};

	return (
		<div className={styles.main}>
			<div className={styles.placeholder}>
				<div className={styles.title}>{translate("dsi.commitment-definition.open-commitments.title")}</div>
				<div className={styles.description}>
					<div>{translate("dsi.commitment-definition.open-commitments.description")}</div>
					<div>{translate("dsi.commitment-definition.open-commitments.ai-feature-name")}</div>
				</div>
				<div
					className={styles.link}
					role="button"
					tabIndex={0}
					onClick={handleNavigateToFeatures}
					onKeyDown={(e) => {
						if (e.key === "Enter" || e.key === " ") {
							handleNavigateToFeatures();
						}
					}}
				>
					{translate("dsi.commitment-definition.open-commitments.link")}
				</div>
			</div>
		</div>
	);
}
